module.exports = __webpack_public_path__ + "img/right_grey_arrow.b115f201.svg";